var map = {
	"./Elephant-Playing-With-Tyres-Taiwan-Zoo": 10,
	"./Elephant-Playing-With-Tyres-Taiwan-Zoo.json": 10,
	"./Garage-Simaya": 11,
	"./Garage-Simaya.json": 11,
	"./Gover-St-Gallery-Mural": 12,
	"./Gover-St-Gallery-Mural.json": 12,
	"./Hong-Kong-Aviary": 13,
	"./Hong-Kong-Aviary.json": 13,
	"./Kung-Fu-Statues": 14,
	"./Kung-Fu-Statues.json": 14,
	"./LABCAT-Meets-Alpaca": 15,
	"./LABCAT-Meets-Alpaca.json": 15,
	"./Making-Mochi-Okegawa-Festival": 16,
	"./Making-Mochi-Okegawa-Festival.json": 16,
	"./Mini-Sushi-Restaurant-1": 17,
	"./Mini-Sushi-Restaurant-1.json": 17,
	"./Peanuts-In-Hong-Kong": 18,
	"./Peanuts-In-Hong-Kong.json": 18,
	"./Spaceman-Building": 19,
	"./Spaceman-Building.json": 19,
	"./Tanuki-Hong-Kong-2019": 20,
	"./Tanuki-Hong-Kong-2019.json": 20,
	"./Ten-Thousand-Buddhas-Monastery-Buddha-On-A-Lion": 21,
	"./Ten-Thousand-Buddhas-Monastery-Buddha-On-A-Lion.json": 21,
	"./Tiny-Frogs-Taiwan-Zoo": 22,
	"./Tiny-Frogs-Taiwan-Zoo.json": 22,
	"./Tobu-Zoo-Winter-Illumination-Trebble-Clef": 23,
	"./Tobu-Zoo-Winter-Illumination-Trebble-Clef.json": 23
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;